import { Dialog, Transition } from '@headlessui/react'
import { Fragment } from 'react'
import { formatDate, formatNumber } from '../../utils/functions'


const CustomerProfitModal = (props) => {
    const { isOpen, closeModal, customerProfit } = props

    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-10" onClose={closeModal}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black/25" />
                </Transition.Child>
                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className="w-full max-w-full transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                                <Dialog.Title
                                    as="h3"
                                    className="text-lg font-medium leading-6 text-gray-900"
                                >
                                    Siparişler
                                </Dialog.Title>
                                <table className='w-full text-left text-zinc-900 text-sm'>
                                    <thead className='text-xs uppercase tracking-wide sticky bg-zinc-50'>
                                        <tr className=''>
                                            <th className='p-2 w-1/12'>Id</th>
                                            <th className='p-2 w-3/12'>
                                                Müşteri
                                            </th>
                                            <th className='p-2 w-2/12'>Tarih</th>
                                            <th className='p-2 w-2/12'>Fatura No</th>
                                            <th className='p-2 w-1/12'>Maliyet</th>
                                            <th className='p-2 w-1/12'>Fiyat</th>
                                            <th className='p-2 w-1/12'>Kar</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            customerProfit?.orders
                                                .sort((a, b) => new Date(b.order.orderDate) - new Date(a.order.orderDate)).map((r, i) => (
                                                    <tr key={i}>
                                                        <td className='p-2'># {r.order.id} </td>
                                                        <td className='p-2'>{r.order.customerName} </td>
                                                        <td className='p-2'>{formatDate(r.order.orderDate)} </td>
                                                        <td className='p-2'>{r.order.invoiceNumber} </td>
                                                        <td className='p-2'>{formatNumber(r.cost)} USD</td>
                                                        <td className='p-2'>{formatNumber(r.order.cost)} {r.order.currency}</td>
                                                        <td className='p-2 text-center'>
                                                            {formatNumber(r.profit)} USD
                                                        </td>
                                                    </tr>
                                                ))
                                        }
                                    </tbody>
                                </table>

                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    )
}

export default CustomerProfitModal